export default "__VITE_ASSET__957078e1__"